"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const entryVarStringInterpolationGetInterpolationNames_1 = __importDefault(require("./entryVarStringInterpolationGetInterpolationNames"));
const entryVarStringInterpolationEvaluate = async ({ evaluateEntryVar, entryVar, }) => {
    const entryVars = entryVar[General_1.DEFINITION_PROP_NAMES.ENTRY_VARS];
    const stringVar = entryVar[General_1.DEFINITION_PROP_NAMES.RAW_STRING];
    if (!stringVar) {
        return '';
    }
    if (!entryVars) {
        return stringVar;
    }
    let updatedStringVar = stringVar;
    const interpolationNames = (0, entryVarStringInterpolationGetInterpolationNames_1.default)(stringVar);
    await Promise.all(interpolationNames.map(async (interpolationName) => {
        if (!interpolationName.isValid) {
            return;
        }
        const entryChild = entryVars
            .find((entryWidhKey) => entryWidhKey[0] === interpolationName.name);
        const childValue = entryChild ? await evaluateEntryVar(entryChild[1]) : '';
        const keyRegex = new RegExp(`\\$\\{${interpolationName.name}\\}`, 'g');
        updatedStringVar = updatedStringVar.replace(keyRegex, `${childValue}`);
    }));
    return updatedStringVar;
};
exports.default = entryVarStringInterpolationEvaluate;
